import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CambioPwdComponent } from '../cambio-pwd/cambio-pwd.component'

@Component({
  selector: 'app-top',
  templateUrl: './top.component.html',
  styleUrls: ['./top.component.css']
})
export class TopComponent implements OnInit {
  @Input() errMsg: string;
  usr:string="";
  menu:any=[];
  menu2:any=[];
  menuMax = false;
  verTextoMenu = false;
  muestraMenuCte = false;


  constructor(private dataService: DataService, public dialog: MatDialog, private router:Router, private dialogRef: MatDialog) { }

  ngOnInit() {
    this.usr = this.dataService.getCurrentUsuario(); 
    this.dataService.getMenu().subscribe(
                    row => { this.menu = <any>row; },
                    error => this.errMsg = <any>error,
                    () => this.fnMenuCargado()
                  );
  }

  fnMenuCargado(){
    //console.log(this.menu);
    var auxMenu;
    var auxMenuImg;
    this.dataService.getMenu2().subscribe(
                      row => { this.menu2 = <any>row; },
                      error => this.errMsg = <any>error,
                      () => this.fnMenu2Cargado()
                    );

    setTimeout(() => {
      for(var i=0; i < this.menu.length; i++){
        auxMenu = document.getElementById("divItem_"+this.menu[i].a);
        auxMenuImg = document.getElementById("divItemImagen_"+this.menu[i].a);
        //console.log(this.menu[i]);
        if(this.menu[i].i){
          auxMenu.style.setProperty("top", (21 + (i * 44)) + "px");
          auxMenuImg.style.backgroundImage = "url('/assets/" + this.menu[i].i + "')";
        }
      }      
      auxMenu=<HTMLDivElement>document.getElementById("divMenu");
      if(auxMenu)
        auxMenu.style.setProperty("display", "none");
    }, 15);
  }

  fnMenu2Cargado(){
    //console.log(this.menu2);   
    for(var i=0; i < this.menu.length; i++){      
      this.menu[i].menu2 = [];
      for(var i2=0; i2 < this.menu2.length; i2++){
        if(this.menu[i].a == this.menu2[i2].tip){
          //console.log(this.menu[i].a + " == " + this.menu2[i2].tip);
          this.menu[i].menu2.push(this.menu2[i2]);
        }
      }
    }
    //console.log("this.menu");
    //console.log(this.menu);
  }

  fnClickMenuItem(event, m1){
    //console.log(event);
    //console.log(m1);
    var auxMenu2;
    for(var i=0; i < this.menu.length; i++){      
      auxMenu2 = document.getElementById("divMenuN2_" + this.menu[i].a);
      auxMenu2.style.setProperty("display", "none");
    }
    auxMenu2 = document.getElementById("divMenuN2_" + m1.a);
    if(m1.a.substr(0,1)=="_"){
      //console.log("MOSTRAR 2do NIVEL: " + m1.a);
      auxMenu2.style.setProperty("display", "inline");
      var auxMenuItems = document.getElementById("divItem_" + m1.a);
    }
    else{
      //console.log("navegar a: " + m1.a)
      this.dataService.insLog('MENU','NAV', m1.a, '').subscribe(
        row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      this.router.navigate([m1.a]);

    }
  }

  fnHome(){
    //console.log("navegar a: HOME")
    this.dataService.insLog('MENU','NAV', 'home', '').subscribe(
      row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.router.navigate(['home']);

  }

  fnOpenMenu(){
    this.menuMax = true
    var auxMenu=<HTMLDivElement>document.getElementById("divMenu");
    auxMenu.style.setProperty("display", "inline");
  }

  fnCloseMenu(){
    this.menuMax = false
    var auxMenu=<HTMLDivElement>document.getElementById("divMenu");
    var auxMenu2;
    auxMenu.style.setProperty("display", "none");
    for(var i=0; i < this.menu.length; i++){      
      auxMenu2 = document.getElementById("divMenuN2_" + this.menu[i].a);
      auxMenu2.style.setProperty("display", "none");
    }

  }

  fnLogOut(){
    this.dataService.insLog('LOGOUT','LOGOUT', sessionStorage.getItem('gempGESusr'), 'SYS').subscribe(
                            row => { var l = <any>row; }, 
                            error => this.errMsg = <any>error, 
                            () => "" );  
    sessionStorage.removeItem('csiBILLlog');
    sessionStorage.removeItem('csiBILLusr');
    sessionStorage.removeItem('csiBILLusrN');
    sessionStorage.removeItem('csiBILLusrR');
    sessionStorage.removeItem('csiBILLusrM');    
    sessionStorage.removeItem('csiBILLusrFAP');
  
    sessionStorage.removeItem('csiMAILh');
    sessionStorage.removeItem('csiMAILp');
    sessionStorage.removeItem('csiMAILus');
    sessionStorage.removeItem('csiMAILpw');
    sessionStorage.removeItem('csiMAILssl');    
    sessionStorage.removeItem('csiMAILtsl');

    this.dialogRef.closeAll();
    this.router.navigate(['login']);
}

fnCambiaContrasena(){
  //console.log("Cambia contraseña");
  let dialogRef = this.dialog.open(CambioPwdComponent, {
    width: "600px",
    data: { 
          id:-1,
          tipo:"CAMBIA PWD",
          timer:0,
          titulo:"Cambio de Contraseña",
          texto1:"",
          btn2:"Continuar"
          }
  });
dialogRef.afterClosed().subscribe(result => {
  console.log("Popup cerrado");
  }); 
}

fnHola(){
  console.log("HOLA!");
}

}
